/* eslint-disable no-invalid-this */
/* eslint-disable max-len */
import ApiService, { IMPORTER_API_CONTEXT, IMPORTER_API_HOST } from './ApiService';

/**
 * @override
 */
class ImportService extends ApiService {
  /**
   * constructor
   */
  constructor() {
    super({ baseURL: IMPORTER_API_HOST });
  }

  /**
   * @override
   */
  upload = (file, context) => {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: function(progressEvent) {
        this.percentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100), 10);
      }.bind(context)
    };
    const formData = new FormData();
    formData.append('attachment', file.attachment, file.attachment.filename);
    formData.append('file_type', file.type);
    return this.post(`${IMPORTER_API_CONTEXT}/uploads`, formData, config);
  };

  /**
   * @override
   */
  uploadWithoutProgress = file => {
    // const config = {
    //   headers: {
    //     'Content-Type': 'multipart/form-data'
    //   }
    // };

    const formData = new FormData();
    formData.append('attachment', file.fileToUpload, file.fileToUpload.filename);
    formData.append('file_type', file.type);
    return this.post(`${IMPORTER_API_CONTEXT}/uploads`, formData);
  };

  /**
   * Get upload
   * @param {String} uuid upload UUID
   * @param {Object} config Axios config
   * @return {Object} Response with upload
   */
  getUploadByUUID = (uuid, config) => {
    return this.get(`${IMPORTER_API_CONTEXT}/uploads/${uuid}`, config);
  };

  /**
   * Get upload
   * @param {Object} config Axios config
   * @return {Object} Response with upload
   */
  listUploads = config => {
    return this.get(`${IMPORTER_API_CONTEXT}/uploads`, config);
  };

  /**
   * Get upload filerecords
   * @param {String} uuid upload UUID
   * @param {Object} config Axios config
   * @return {Object} Response with upload
   */
  listUploadFilerecords = (uuid, config) => {
    return this.getList(`${IMPORTER_API_CONTEXT}/uploads/${uuid}/filerecords`, config);
  };

  downloadUploadErrorsLogByUuid = (uuid, config) => {
    return this.get(`${IMPORTER_API_CONTEXT}/uploads/${uuid}/logs`, config);
  };
}

const importService = new ImportService();

export default importService;
